import React, { useState } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import apiService from '../api/api';

function Login({ onSignInSuccess, onSignInError }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSuccess = async (credentialResponse) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.googleSignIn(credentialResponse.credential);

      if (response.status === 'success') {
        localStorage.setItem('user', JSON.stringify(response.user));
        localStorage.setItem('authToken', response.token);
        onSignInSuccess(response.user);
      } else {
        const errorMsg = response.message || 'Sign-in failed';
        setError(errorMsg);
        onSignInError(errorMsg);
      }
    } catch (err) {
      const errorMsg = err.message || 'Sign-in failed';
      setError(errorMsg);
      onSignInError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleError = () => {
    const errorMsg = 'Google Sign-In failed';
    setError(errorMsg);
    onSignInError(errorMsg);
  };

  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  if (!clientId) {
    return (
      <div className="login-error-container">
        <div className="login-error-icon">⚠️</div>
        <h3>Configuration Error</h3>
        <p>
          Google Client ID is not configured.
          <br />
          Please add <code>REACT_APP_GOOGLE_CLIENT_ID</code> to <code>frontend/.env.local</code>
        </p>
      </div>
    );
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div className="signin-wrapper">
        {error && (
          <div className="signin-error-message">
            <span className="signin-error-icon">⚠️</span>
            <p>{error}</p>
          </div>
        )}

        {loading ? (
          <div className="signin-loading">
            <span className="signin-spinner"></span>
            <p>Signing in...</p>
          </div>
        ) : (
          <div className="signin-button-container">
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={handleError}
              size="large"
              text="signin_with"
              theme="filled_black"
              logo_alignment="left"
            />
          </div>
        )}
      </div>
    </GoogleOAuthProvider>
  );
}

export default Login;
